import { render, staticRenderFns } from "./stayGiveup.vue?vue&type=template&id=65bf8962"
import script from "./stayGiveup.vue?vue&type=script&lang=js"
export * from "./stayGiveup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports